import { Home as HomeTemplate } from "components/templates";
import { ReactHelmetWithProvider } from "providers/ReactHelmetProvider";

const Home = () => (
  <div className="home-page">
    <ReactHelmetWithProvider>
      <meta
        name="description"
        content="From retail and restaurants to gas and groceries, you'll find discounts on thousands of your favorite brands. Start saving today."
      />
      <title>Buy & Sell Discounted Gift Cards - Save Today! | GCX</title>
      <link rel="canonical" href={process.env.REACT_APP_URL} />
    </ReactHelmetWithProvider>
    <HomeTemplate />
  </div>
);

export default Home;
